import { useNavigate } from 'react-router-dom';
import { Eye, Pencil, LogOut, ShieldAlert } from 'lucide-react';
import { useImpersonation } from '../contexts/ImpersonationContext';

/**
 * Slim fixed bar shown across the CRM while a super admin is browsing a tenant.
 * Makes the impersonation state unmissable and offers the read-only/edit toggle
 * plus an exit back to the super-admin console.
 */
export default function ImpersonationBanner() {
  const { impersonation, stop, setEdit } = useImpersonation();
  const navigate = useNavigate();

  if (!impersonation) return null;

  const { gymName, edit } = impersonation;

  const exit = () => {
    stop();
    navigate('/saas/manage');
  };

  return (
    <div
      className={`fixed top-0 inset-x-0 z-[1000] flex items-center justify-center gap-3 px-3 py-1.5 text-xs font-semibold text-white shadow-md ${
        edit ? 'bg-red-600' : 'bg-amber-600'
      }`}
    >
      <ShieldAlert className="w-4 h-4 shrink-0" />
      <span className="truncate">
        Browsing as <span className="font-black">{gymName}</span>
        <span className="hidden sm:inline"> · {edit ? 'Edit mode — changes are live' : 'Read-only'}</span>
      </span>

      <button
        onClick={() => setEdit(!edit)}
        className="ml-1 inline-flex items-center gap-1 rounded-full bg-white/20 px-2.5 py-0.5 hover:bg-white/30 transition-colors"
        title={edit ? 'Switch to read-only browsing' : 'Allow changes to this gym'}
      >
        {edit ? <Pencil className="w-3 h-3" /> : <Eye className="w-3 h-3" />}
        {edit ? 'Editing' : 'Enable edit'}
      </button>

      <button
        onClick={exit}
        className="inline-flex items-center gap-1 rounded-full bg-black/25 px-2.5 py-0.5 hover:bg-black/40 transition-colors"
      >
        <LogOut className="w-3 h-3" />
        Exit
      </button>
    </div>
  );
}
